import PhotoSwipe from './index.vue';

export default PhotoSwipe;
